// frontend/src/components/GlobalCronometroToast.jsx

import React from 'react';
import { useCronometro } from '../context/CronometroContext';
import './CronometroToast.css';

const GlobalCronometroToast = () => {
  const { tareasActivas, timers, formatTime, detenerCronometro } = useCronometro();

  const handleDetener = async (tareaId) => {
    try {
      await detenerCronometro(tareaId);
    } catch (error) {
      console.error('Error al detener cronómetro:', error);
    }
  };

  // ⭐ Siempre renderizar el contenedor para evitar problemas con pointer-events
  // El contenedor tendrá pointer-events: none cuando está vacío, no afectando al nav
  return (
    <div className="cronometro-toast-container">
      {tareasActivas.map(tarea => (
        <div key={tarea.id} className="cronometro-toast">
          <div className="cronometro-toast-header">
            <div className="cronometro-toast-icon">
              <i className="fas fa-stopwatch"></i>
            </div>
            <div className="cronometro-toast-info">
              <h4 className="cronometro-toast-title">{tarea.nombre_tarea}</h4>
              {tarea.cliente_nombre && (
                <span
                  className="cronometro-toast-cliente"
                  style={{ backgroundColor: tarea.cliente_color || '#6b7280' }}
                >
                  {tarea.cliente_nombre}
                </span>
              )}
            </div>
            <button
              className="cronometro-toast-close"
              onClick={() => handleDetener(tarea.id)}
              title="Detener cronómetro"
            >
              <i className="fas fa-stop"></i>
            </button>
          </div>

          <div className="cronometro-toast-time">
            <span className="time-label">Tiempo:</span>
            <span className="time-value">
              {formatTime(timers[tarea.id] || tarea.total_time_seconds)}
            </span>
          </div>

          {tarea.timer_active_user_name && (
            <div className="cronometro-toast-user">
              <i className="fas fa-user"></i>
              <span>{tarea.timer_active_user_name}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default GlobalCronometroToast;